import { createRef, useContext, useState } from "react";
import { PageContext } from "../common/pages";
import { Admin, AdminCrusade, useAdmin } from "../components/admin";
import { CPage } from "../components/cr.ui.page";
import { UButton, UListItemButton } from "../common/ui.buttons";
import { ListItemText, MenuItem, Select, TextField, Typography } from "@mui/material";
import { USection } from "../common/ui.page";
import { PageAdminCrusade } from "./p.admin.crusade";
import { EXT_NAMES } from "../components/cr.ext";


export function PageAdmin(props) {
    const admin = useAdmin()
    const { path } = useContext(PageContext)

    if (path.length > 1) {
        return <AdminCrusade id={path[1]}><PageAdminCrusade /></AdminCrusade>
    }

    return <CPage>
        <USection>
            <Typography>Crociate attive</Typography>
            {admin.crusades.map(c => <UListItemButton key={c.id} page={"admin/" + c.id}>
                <ListItemText primary={c.name} secondary={EXT_NAMES[c.ext]} />
                <UButton onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    admin.removeCrusade(c.id)
                }}>Cancella</UButton>
            </UListItemButton>)}
        </USection>

        <NewCrusade />

    </CPage>

}

function NewCrusade() {
    const admin = useAdmin()
    const [data, setData] = useState({ name: '', ext: 'VANILLA' })
    return <USection>
        <Typography>Nuova Crociata</Typography>
        <TextField size="small" label="Name" value={data.name} onChange={e => setData({ ...data, name: e.target.value })} />
        <Select value={data.ext} onChange={e => setData({ ...data, ext: e.target.value })}>
            {Object.keys(EXT_NAMES).map(k => <MenuItem key={k} value={k}>
                {EXT_NAMES[k]}
            </MenuItem>)}
        </Select>
        <UButton onClick={() => admin.newCrusade(data)}>Crea</UButton>
    </USection>
}